import { render, staticRenderFns } from "./ScreensSection.vue?vue&type=template&id=6fba927f&scoped=true"
import script from "./ScreensSection.vue?vue&type=script&lang=js"
export * from "./ScreensSection.vue?vue&type=script&lang=js"
import style0 from "./ScreensSection.vue?vue&type=style&index=0&id=6fba927f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba927f",
  null
  
)

export default component.exports